<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';
import { Primitive } from 'reka-ui';

const props = withDefaults(
  defineProps<
    PrimitiveProps & {
      size?: 'sm' | 'md';
      isActive?: boolean;
      class?: HTMLAttributes['class'];
    }
  >(),
  {
    as: 'a',
    size: 'md',
  },
);
</script>

<template>
  <Primitive
    data-sidebar="menu-sub-button"
    :as="as"
    :asChild="asChild"
    :data-size="size"
    :data-active="isActive"
    :class="
      cn(
        'ring-sidebar-ring glass-button flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-white outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0',
        'data-[active=true]:border-white/45 data-[active=true]:bg-white/35',
        size === 'sm' && 'text-xs',
        size === 'md' && 'text-sm',
        'group-data-[collapsible=icon]:hidden',
        props.class,
      )
    "
  >
    <slot />
  </Primitive>
</template>
